// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__ZlchT","left":"style_left__4wkkl","right":"style_right__Eqbj0","disabled":"style_disabled__4b6Mx","center":"style_center__Ayxh4"};